module.exports = __webpack_public_path__ + "img/base_activites_zoo.9ed5bd61.svg";